export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/company_client_reviews/state.js